import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Notification from 'components/notification';

export default class ClipboardCopy extends PureComponent {
  static propTypes = {
    successMessage: PropTypes.string,
    warningMessage: PropTypes.string,
  };

  static defaultProps = {
    successMessage: 'Ссылка скопирована в буфер обмена',
    warningMessage: 'Данная функция не поддерживается Вашим браузером',
  };

  constructor(props, ctx) {
    super(props, ctx);
    this.copy = this.copy.bind(this);
    this.state = {
      clientRendered: false
    };
  }

  componentDidMount() {
    // eslint-disable-next-line
    this.setState({ clientRendered: true });
  }

  copy(text, callBack) {
    let available = true;
    this.setState(
      { renderPhantom: true }, // render phantom textarea
      () => {
        this.phantom.value = text;

        if (navigator.userAgent.match(/ipad|ipod|iphone/i)) {
          // TODO: detect mobile Safari
          this.phantom.focus();
          const editable = this.phantom.contentEditable;
          const readOnly = this.phantom.readOnly;
          this.phantom.contentEditable = true;
          this.phantom.readOnly = false;
          const range = document.createRange();
          range.selectNodeContents(this.phantom);
          const sel = window.getSelection();
          sel.removeAllRanges();
          sel.addRange(range);
          this.phantom.setSelectionRange(0, 999999);
          this.phantom.contentEditable = editable;
          this.phantom.readOnly = readOnly;
        } else {
          this.phantom.select();
        }

        available = document.queryCommandEnabled('copy');
        document.execCommand('copy');
        return this.setState(
          { renderPhantom: false },
          () => {
            if (!available) {
              Notification.warning(this.props.warningMessage, null);
            } else {
              Notification.success(this.props.successMessage, null);
            }
            if (callBack) callBack();
          }
        );
      }
    );
  }

  render() {
    if (this.state.clientRendered && this.state.renderPhantom) {
      // TODO: phantom DOM-element for copy to clipboard in Safari
      return (
        <textarea
          style={{
            position: 'fixed',
            opacity: '0'
          }}
          ref={ref => this.phantom = ref}
          defaultValue="phantom"
        />
      );
    }

    return null;
  }
}
